export default class SkillContentModel {
    constructor(title, icon, items) {
        this.title = title;
        this.icon = icon;
        this.items = items;
    }
}